export default __webpack_public_path__ + "static/media/cases7@2x.b633bd2b.webp";